export const CategoryEnum = {
    Prepayment: "PREPAYMENT"
}